// -- Imports -- //
require('onbrandutilityfunctions/build/conditional-babel-polyfill.bundle.js'); // use all the things!
const onbrandUtilityFunctions = require('onbrandutilityfunctions');
const devOptions = require('./dev-options.js'); //Development options
const onbrandScss = require('./onbrand.scss'); //Onbrand styles
const clientScss = require('./client/client.scss'); //client styles
const htmlHeader = require('./includes/header.html');
const htmlFooter = require('./includes/footer.html');
const socialMediaBar = require('./includes/social-bar.html');
const socialMediaFunctionality = require('./scriptPartials/socialLinks');
const frontEndTagging = require('./scriptPartials/tagging');
const shareContent = require('./scriptPartials/socialMediaOnContent');
const addClearfix = require('./scriptPartials/addClearfix');
const removeHighlightTile = require('./scriptPartials/removeHighlightTile');
const addIcons = require('./scriptPartials/addViewLinkIcon');

const handleClientHeader = require('./modules/handleClientHeader');
const { addTitleContainer } = require('./scriptPartials/handleItemLevelTitle');

module.exports = {
  initOnbrand: function initOnbrand(translations, production) {
    // -- Startup -- //
    production ? null : onbrandUtilityFunctions.devMode(devOptions);
    $('body').prepend(htmlHeader(translations));
    $('body').append(htmlFooter(translations));
    $('.right-side-btns').append(socialMediaBar);
    window.onbrandLoaded = false;

    // old time embed error throw "fix" (TODO: make this better)
    onbrandUtilityFunctions.legacyEmbedTileFix();
    // Remove the "touch" class on touchscreen laptops
    onbrandUtilityFunctions.removeTouchForLaptops();
    // Remove the hub function updateOverlaySize
    onbrandUtilityFunctions.overrideHubFuctions();
    // Adds body classes for content type (blogPost, youtube, sales-stream etc)
    onbrandUtilityFunctions.helpfulClasses();
    // Rebuild the share widget for the top-nav
    onbrandUtilityFunctions.fixShareWidgetImproved();
    // warns you if your query string is missing.
    onbrandUtilityFunctions.noQueryStringSafeguard();
    // makes the reco engine sticky to the target / top of screen
    onbrandUtilityFunctions.recoEnginePositioning('.top-nav');

    // OPENS "STATE OF CONVERSATION INTELLIGENCE 2020" TILE IN NEW TAB
    const openTileInNewTab = () => {
      const selectedTile = document.querySelector('.tile.single[data-id="569063514"]');

      if (selectedTile) {
        const tileLink = [...selectedTile.querySelectorAll('.item-link')];

        tileLink.forEach((link) => {
          link.setAttribute('target', '_blank');
        });
      }
    };

    // -- Hub Events -- //
    Hubs.Events
      .on('load', () => {
        if (!window.onbrandLoaded) {
          // Add your onloads here...
          onbrandUtilityFunctions.blockCtaFix();
          onbrandUtilityFunctions.fadeOutItem();
          handleClientHeader();
          frontEndTagging();
          shareContent();
          socialMediaFunctionality();
          addClearfix();
          removeHighlightTile();
          addIcons();
          addTitleContainer();
          openTileInNewTab();
          // end your onloads before here...
          window.onbrandLoaded = true;
        }
      })
      .on('itemsLoaded', (itemIds, selectors) => {
        frontEndTagging();
        addIcons();
      }) //eslint-disable-line no-unused-vars
      .on('resize', () => {
        // adjust side cta or addThis by passing a number into the function
        // eg onbrandUtilityFunctions.sideCtaFix(150); will push the side cta down by 150px, do the same for on scroll
        onbrandUtilityFunctions.sideCtaFix();
        onbrandUtilityFunctions.addThisFix();
      })
      .on('scroll', () => {
        onbrandUtilityFunctions.sideCtaFix();
        onbrandUtilityFunctions.addThisFix();
        onbrandUtilityFunctions.blockCtaFix();
        onbrandUtilityFunctions.fadeOutItem();
      })
      .on('ctaActivate', (ctaId) => { }) //eslint-disable-line no-unused-vars
      .on('ctaFormSubmitSuccess', (ctaId, mappedData, ctaName) => { }); //eslint-disable-line no-unused-vars

    // The new hub events can trigger before cihost scripts are loaded.
    // This will ensure your scripts fire no matter what, but not more than once for 'load'.
    if (!window.onbrandLoaded) {
      Hubs.Events.trigger('load');
    }
  },
};



// WEBPACK FOOTER //
// ./onbrand.js